export class OrdersDataType {
  public static TRADING_ORDERS = "TradingOrders";
  public static TRADING_MARKET_ACTIVITIES = "TradingMarketActivities";
  public static TRADING_ORDER_DETAILS = "TradingOrderDetails";
  public static CONTRACT_MARKET_DATA = "ContractMarketData";
  public static TRADING_GRID_GROUPS = "TradingGridGroups";
  public static TRADING_USER_DETAILS = "TradingUserDetails";
  public static TRADING_GRID_GROUP_ITEM_MARKET_DATA =
    "TradingGridGroupItemMarketData";
}

export class OrdersType {
  public static ORDERS_DATA_SUBSCRIBE = "ordersDataSubscribe";
  public static ORDERS_DATA_UNSUBSCRIBE = "ordersDataUnsubscribe";
  public static CONTRACT_MARKET_DATA = "ContractMarketData";
  public static TRADING_MARKET_ACTIVITIES = "TradingMarketActivities";
  public static TRADING_GRID_GROUP_ITEM_MARKET_DATA =
    "TradingGridGroupItemMarketData";
  public static OPTIONS_GRID_GROUP = "OptionsGridGroup";
  public static OPTIONS_GRID_GROUP_ITEM = "OptionsGridGroupItem";
  public static OPTIONS_GRID_GROUP_ITEM_DEPTH = "OptionsGridGroupItemDepth";
  public static OPTIONS_GRID_EXPIRY = "cmedOptionsGridExpiry";
  public static UNDERLYING = "underlying";
  public static FIND_OPTIONS = "findOptions";
}
